import { Link } from "@StarberryUtils";
import React from "react";
import { Col, Row, Container, Table } from 'react-bootstrap';
import "./Owners.scss";
import { useQuery } from '@apollo/client';
import gql from "graphql-tag"
import $ from "jquery";

const Availability = (props) => {



    const PROPERTY = gql`
query GetSingleProperty($URL: String!){ 
    properties(where:{primary_development: $URL,publish:true}){
        crm_id
        primary_development
        search_type
        building
        bedroom
        bathroom
        status
        price_qualifier
        price
        max_price
        brochure
        id
        slug
        floorarea_min
   }
}
`;

    const { loading, error, data } = useQuery(PROPERTY, {
        variables: { URL: props.id }
    });

    if (loading) return (
        <div className="static-news gql-loading-screen">
            <Container>
                <div className="gql-loading">Loading ...</div>
            </Container>
        </div>);

    if (data.properties.length == 0) {
        $(".main-availability-menu").hide();
    }

    return (
        <>
            {data.properties.length != 0 ?
                <section className="property-new-home-availability" id="availability">
                    <Container>
                        <Row className="d-flex justify-content-center">
                            <Col lg={8} className="property-newhomes-heading">
                                <h3>Availability</h3>

                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12}>
                                <Table responsive className="property-availability-table">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Bedrooms</th>
                                            <th>Bathrooms</th>
                                            <th>SQ FT.</th>
                                            <th>SQ MT.</th>
                                            <th>Price</th>
                                            <th>Status</th>
                                            <th>Details</th>
                                            <th>Brochure</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.properties.map((data, index) => {
                                            // property details url structure
                                            let uriStr = "";

                                            if (data.search_type === "sales") {
                                                uriStr = `property-for-sale/`
                                            } else if (data.search_type === "lettings") {
                                                uriStr = `property-to-rent/`
                                            }

                                            // property details url structure

                                            return (
                                                <tr>
                                                    <td className="availability-building-head">{data.building}</td>
                                                    <td>{data.bedroom}</td>
                                                    <td>{data.bathroom}</td>
                                                    <td>{data.floorarea_min ? data.floorarea_min : 'N/A'}</td>
                                                    <td>{data.floorarea_min ? Math.round(data.floorarea_min / 10.764) : 'N/A'}</td>
                                                    <td>{data.price_qualifier} &pound;{data.price.toLocaleString()}</td>
                                                    <td>Available</td>
                                                    <td><Link to={'/' + uriStr + data.slug +'/'+data.crm_id?.toLowerCase()} className="property-availability-link">View Details</Link></td>
                                                    <td>{data.brochure && data.brochure.length != 0 ? <a href={data.brochure[0].url} target="_blank" className="property-availability-link">Download</a> : 'N/A'}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </Container>
                </section> :
                // <p className="empty-space"></p>
                ""
            }
        </>
    )
}

export default Availability
